/** Нормализация к E.164-подобному +7… для API */
export function toApiPhone(raw: string): string {
  const d = raw.replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('8')) {
    return `+7${d.slice(1)}`;
  }
  if (d.length === 10) {
    return `+7${d}`;
  }
  if (d.length === 11 && d.startsWith('7')) {
    return `+${d}`;
  }
  if (raw.trim().startsWith('+') && d.length > 0) {
    return `+${d}`;
  }
  return d ? `+${d}` : '';
}

/** Маска отображения для react-hook-form: +7 (XXX) XXX-XX-XX */
export function formatPickupPhoneForInput(value: string): string {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length === 0) return '';
  let normalizedNumbers = numbers.startsWith('8') ? '7' + numbers.slice(1) : numbers;
  if (!normalizedNumbers.startsWith('7') && normalizedNumbers.length > 0) {
    normalizedNumbers = '7' + normalizedNumbers;
  }
  const limitedNumbers = normalizedNumbers.slice(0, 11);
  if (limitedNumbers.length === 0) return '';
  if (limitedNumbers.length <= 1) return `+${limitedNumbers}`;
  if (limitedNumbers.length <= 4) return `+${limitedNumbers.slice(0, 1)} (${limitedNumbers.slice(1)}`;
  if (limitedNumbers.length <= 7) return `+${limitedNumbers.slice(0, 1)} (${limitedNumbers.slice(1, 4)}) ${limitedNumbers.slice(4)}`;
  if (limitedNumbers.length <= 9) return `+${limitedNumbers.slice(0, 1)} (${limitedNumbers.slice(1, 4)}) ${limitedNumbers.slice(4, 7)}-${limitedNumbers.slice(7)}`;
  return `+${limitedNumbers.slice(0, 1)} (${limitedNumbers.slice(1, 4)}) ${limitedNumbers.slice(4, 7)}-${limitedNumbers.slice(7, 9)}-${limitedNumbers.slice(9, 11)}`;
}
